import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Label, Row, Badge } from "reactstrap"
import axios from "axios"
import Select from "react-select"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap"
const Home = () => {
  const token = JSON.parse(localStorage.getItem("Token"))
  const [selectedEvents, setSelectedEvents] = useState([])
  const [Events, setEvents] = useState([])

  const baseUrl = "https://marcopolo.prisms.in/api/teacher-calendar/calendars"

    const enLocal = {
    "code": "en-nz",
    "week": {
      "dow": 1,
      "doy": 4
    },
    "buttonHints": {
      "prev": "Previous $0",
      "next": "Next $0",
      "today": "This $0"
    },
    "viewHint": "$0 view",
    "navLinkHint": "Go to $0"
  };
  const [isLocal, setIsLocal] = useState(enLocal);
  const handleChangeLocals = (value) => {
    setIsLocal(value);
  };
  const getEvents = async () => {
    try {
      const response = await axios.get(baseUrl, {
        headers: {
          Authorization: token,
        },
      })

      const eventData = response.data.data

      const formattedOptions = eventData.map(event => ({
        value: event.id,
        label: event.title,
        color_code: event.color_code,
      }))

      setEvents(formattedOptions)
      // setSelectedEvents(formattedOptions)
    } catch (error) {
      console.error("Error fetching events:", error)
    }
  }

  useEffect(() => {
    getEvents()
  }, [])

  const handleChange = selected => {
    setSelectedEvents(selected)
    console.log("Selected events:", selected)
  }

  return (
    <Row className="mt-5 py-4">
      <Container className="p-3">
        <Card className="shadow-lg rounded-lg">
          <CardBody className="p-2">
            {" "}
            <Select
              options={Events}
              value={selectedEvents}
              onChange={handleChange}
              isMulti
              closeMenuOnSelect={false}
              placeholder="Select Calendar"
            />
          </CardBody>

          <Col xl={9} className="mt-5">
            <Card>
              <CardBody>
                <FullCalendar
                  plugins={[
                    BootstrapTheme,
                    dayGridPlugin,
                    interactionPlugin,
                  ]}
                  slotDuration={"00:15:00"}
                  handleWindowResize={true}
                  themeSystem="bootstrap"
                  headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,dayGridWeek,dayGridDay,listWeek",
                  }}
                  locale={isLocal}
                  events={''}
                  editable={true}
                  droppable={true}
                  selectable={true}
                  // eventClick={handleEventClick}
                />
              </CardBody>
            </Card>
          </Col>
        </Card>
      </Container>{" "}
    </Row>
  )
}

export default Home
